module.exports = __webpack_public_path__ + "static/media/eurofins-bpt.af479427.jpg";